/**
 * Shared public boot timing.
 * Cold: full brand floor. Warm (same tab session after first boot_complete): shorter.
 */
export const BOOT_MIN_VISIBLE_MS = 700;
export const BOOT_MIN_VISIBLE_WARM_MS = 320;
export const BOOT_RELEASE_DURATION_MS = 460;
export const BOOT_RELEASE_EASING = "cubic-bezier(0.22, 1, 0.36, 1)";

/** Soft ceiling so a missing routeReady cannot hang the splash forever. */
export const BOOT_ROUTE_READY_FAIL_OPEN_MS = 4000;

/**
 * Cold marketing entry (`/` / `/start`): splash must not wait on long auth restore.
 * Session may still resolve under the Start UI after this window.
 */
export const BOOT_COLD_ENTRY_AUTH_FAIL_OPEN_MS = 400;

export const BOOT_WARM_SESSION_KEY = "folyamat_boot_warm";

export function readBootMinVisibleMs(
  storage: Pick<Storage, "getItem"> | null | undefined = typeof sessionStorage === "undefined"
    ? null
    : sessionStorage,
): number {
  try {
    if (storage?.getItem(BOOT_WARM_SESSION_KEY) === "1") {
      return BOOT_MIN_VISIBLE_WARM_MS;
    }
  } catch {
    // Private mode / blocked storage — cold path.
  }
  return BOOT_MIN_VISIBLE_MS;
}

export function markBootWarmSession(
  storage: Pick<Storage, "setItem"> | null | undefined = typeof sessionStorage === "undefined"
    ? null
    : sessionStorage,
): void {
  try {
    storage?.setItem(BOOT_WARM_SESSION_KEY, "1");
  } catch {
    // ignore
  }
}
